import React, { useEffect, useState } from 'react';
import MultiSelect from '../MultiSelect';
import BaseService from '../../services/BaseService';

const MultiSelectOptions = ({ onSelect, value, label, url, disabled }) => {
  const [options, setOptions] = useState([]);
  
  const getOptions = async () => {
    try {
      const response = await BaseService.get({ url: url });
      setOptions(response.data.map(o => ({ value: o.id, label: o.label })));
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    getOptions();
  }, []);

  return (
    <MultiSelect
      label={label}
      disabled={disabled}
      onChange={values => {
        onSelect(values ? values.map(v => v.value) : null)
      }}
      defaultValue={options && value? options.filter(o => value.indexOf(o.value) > -1).map(o => ({ value: o.value, label: o.label })) : []}
      options={options}
    />
  )
}

export default MultiSelectOptions;